import * as i0 from '@angular/core';
import { EventEmitter, ViewChild, Output, Input, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import tippy from 'tippy.js';

class E11TooltipComponent {
    constructor() {
        this.position = 'top';
        this.interactive = false;
        this.maxWidth = 350;
        this.delay = 100; // https://atomiks.github.io/tippyjs/v6/all-props/#delay
        this.tooltipClick = new EventEmitter();
    }
    ngAfterViewInit() {
        this.initTippy();
    }
    initTippy() {
        tippy(this.contentWrapper.nativeElement, {
            animation: 'shift-away',
            delay: this.delay,
            content: this.tooltip.nativeElement,
            placement: this.position,
            interactive: this.interactive,
            offset: [0, 12],
            theme: this.color,
            allowHTML: true,
            maxWidth: this.maxWidth,
            onShow: (_) => {
                if (this.hideTooltip) {
                    return false;
                }
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11TooltipComponent, selector: "e11-tooltip", inputs: { tooltipText: "tooltipText", tooltipClassOverrides: "tooltipClassOverrides", hideTooltip: "hideTooltip", color: "color", tooltipContent: "tooltipContent", position: "position", interactive: "interactive", maxWidth: "maxWidth", delay: "delay" }, outputs: { tooltipClick: "tooltipClick" }, viewQueries: [{ propertyName: "contentWrapper", first: true, predicate: ["contentWrapper"], descendants: true }, { propertyName: "tooltip", first: true, predicate: ["tooltip"], descendants: true }], ngImport: i0, template: `
    <div class="e11-tooltip e11-flex e11-cursor-pointer">
      <span #contentWrapper class="e11-inline-flex">
        <ng-content></ng-content>
      </span>
      <div #tooltip class="e11-p-1 e11-cursor-pointer {{ tooltipClassOverrides }}" (click)="tooltipClick.emit($event)">
        <div *ngIf="tooltipText" class="e11-mb-1 e11-text-sm">
          {{ tooltipText }}
        </div>
        <ng-container *ngIf="tooltipContent" [ngTemplateOutlet]="tooltipContent"></ng-container>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-tooltip',
                    template: `
    <div class="e11-tooltip e11-flex e11-cursor-pointer">
      <span #contentWrapper class="e11-inline-flex">
        <ng-content></ng-content>
      </span>
      <div #tooltip class="e11-p-1 e11-cursor-pointer {{ tooltipClassOverrides }}" (click)="tooltipClick.emit($event)">
        <div *ngIf="tooltipText" class="e11-mb-1 e11-text-sm">
          {{ tooltipText }}
        </div>
        <ng-container *ngIf="tooltipContent" [ngTemplateOutlet]="tooltipContent"></ng-container>
      </div>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [], propDecorators: { tooltipText: [{
                type: Input
            }], tooltipClassOverrides: [{
                type: Input
            }], hideTooltip: [{
                type: Input
            }], color: [{
                type: Input
            }], tooltipContent: [{
                type: Input
            }], position: [{
                type: Input
            }], interactive: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], delay: [{
                type: Input
            }], tooltipClick: [{
                type: Output
            }], contentWrapper: [{
                type: ViewChild,
                args: ['contentWrapper']
            }], tooltip: [{
                type: ViewChild,
                args: ['tooltip']
            }] } });

class E11TooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipModule, declarations: [E11TooltipComponent], imports: [CommonModule], exports: [E11TooltipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11TooltipComponent],
                    imports: [CommonModule],
                    exports: [E11TooltipComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11TooltipComponent, E11TooltipModule };
